<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g;
import ActionButton from "../ActionButton/ActionButton.svelte";
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { Readable, get } from 'svelte/store';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext, onMount } from 'svelte';
import { resolveUrl } from '../../../../../js/url';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import _ from 'lodash';
import { f7 } from 'framework7-svelte';
import { CardsPageContext, CardsPageContextKey } from '../../../common/context';
import { ycAnalyticsTrackMParticle } from '../../../../../js/ycapp';
import { YinzCamAppServer, YinzCamAppServerToken } from 'yinzcam-appserver';
export let element;
export let sources;
export let sourceStore;
const pageContext = getContext(CardsPageContextKey);
const tabContext = getContext(CardsTabContextKey);
const signonManager = getToken(ROOT, JanusSignonManagerToken);
const appsrv = getToken(ROOT, YinzCamAppServerToken);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: buttonLabel = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.buttonLabel) || "Save";
$: fieldMapping = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.fieldMapping) || {};
$: nextPage = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.nextPage) || 'ConnectAccounts';
$: endWorkflow = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.endWorkflow) || false;
$: trackJanusAnalytics = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.trackJanusAnalytics) || false;
$: trackMParticleAnalytics = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.trackMParticleAnalytics) || false;
/*
{
    "addressKey": {
        "type": "address",
        "profileKey": {
            "address_country": "address_country",
            "address_street": "address_street",
            "address_city": "address_city",
            "address_division_1": "address_division_1",
            "address_postal": "address_postal",
            "phone": "phone"
        },
        "required": {
            "address_country": true,
            "phone": true
        }
    },
    "firstNameKey": {
        "profileKey": "first_name",
        "required": true
    },
    ...
}
*/
$: formState = (function (mergedParams, fieldMapping) {
    var _a;
    const ret = { profile: {}, valid: true };
    for (let [formKey, config] of Object.entries(fieldMapping)) {
        if (!formKey || !config)
            continue;
        if (formKey.startsWith('$'))
            formKey = (mergedParams || {})[formKey.slice(1)];
        const formValue = (mergedParams || {})[formKey] || '';
        if (config.type === 'address') {
            const addressValue = (formValue) ? JSON.parse(formValue) : {};
            const profileKeyConfig = config.profileKey || {};
            for (const [addressSubkey, profileKey] of Object.entries(profileKeyConfig)) {
                if (!addressSubkey || !profileKey)
                    continue;
                const subkeyValue = addressValue[addressSubkey] || '';
                ret.profile[profileKey] = subkeyValue;
                if (((_a = config.required) === null || _a === void 0 ? void 0 : _a[addressSubkey]) === true && !subkeyValue) {
                    console.log('address subkey not valid: ', addressSubkey, addressValue, subkeyValue);
                    ret.valid = false;
                }
            }
        }
        else {
            let profileKey = config.profileKey;
            if (!profileKey)
                continue;
            if (profileKey.startsWith('$'))
                profileKey = (mergedParams || {})[profileKey.slice(1)];
            ret.profile[profileKey] = formValue;
            //console.log(`ret.profile[${profileKey}] = ${formValue} (${typeof formValue})`);
            if (config.required === true && (!formValue || formValue === 'false')) {
                console.log('profile key not valid', formKey, formValue);
                ret.valid = false;
            }
        }
    }
    // make sure booleans are sent as strings
    for (const [profileKey, profileValue] of Object.entries(ret.profile)) {
        if (_.isBoolean(profileValue)) {
            ret.profile[profileKey] = (profileValue) ? "true" : "false";
        }
    }
    return ret;
})($mergedParams, fieldMapping);
$: console.log('form profile: ', formState.profile);
$: console.log('form valid: ', formState.valid);
const handleClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
    var _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const params = $mergedParams || {};
    if (!formState.valid)
        return;
    if (trackJanusAnalytics) {
        pageContext.getAnalytics().sendInteractionEvent('SUBMIT_BUTTON_CLICK', buttonLabel);
    }
    if (trackMParticleAnalytics && CONFIG.league === 'fa' && CONFIG.tricode === 'tot') {
        if (params['event_id']) {
            const rsp = yield appsrv.getEventDetail(params['event_id']);
            const attributes = {
                'competition_name': (_k = (_j = (_h = rsp.data) === null || _h === void 0 ? void 0 : _h.CalendarEventXml) === null || _j === void 0 ? void 0 : _j._attributes) === null || _k === void 0 ? void 0 : _k.Title,
                'competition_start_date': (_o = (_m = (_l = rsp.data) === null || _l === void 0 ? void 0 : _l.CalendarEventXml) === null || _m === void 0 ? void 0 : _m._attributes) === null || _o === void 0 ? void 0 : _o.Date,
                'competition_end_date': (_r = (_q = (_p = rsp.data) === null || _p === void 0 ? void 0 : _p.CalendarEventXml) === null || _q === void 0 ? void 0 : _q._attributes) === null || _r === void 0 ? void 0 : _r.EndTime,
            };
            ycAnalyticsTrackMParticle('click/tap', 'Competition Submit', 'navigation', attributes);
        }
        else {
            const attributes = {
            //'spurs_fan_years': (formState.profile['fan_since_year'])? (new Date().getFullYear() - parseInt(formState.profile['fan_since_year'])).toString() : ''
            };
            setTimeout(() => {
                ycAnalyticsTrackMParticle('click/tap', 'Profile Complete', 'navigation', attributes);
            }, 2000);
            //ycAnalyticsTrackMParticle('click/tap', 'Profile Complete', 'navigation', attributes);
        }
    }
    let result;
    f7.preloader.show('white');
    try {
        result = yield signonManager.updateUserProfileSegment(formState.profile);
    }
    finally {
        f7.preloader.hide();
    }
    if (result.success) {
        if (endWorkflow) {
            signonManager.fireWorkflowEndEvent();
        }
        else {
            resolveUrl(nextPage).func();
        }
    }
    else {
        alert(((_t = (_s = result.data) === null || _s === void 0 ? void 0 : _s.UserMessage) === null || _t === void 0 ? void 0 : _t.Content) || 'An error occurred.');
    }
});
let sentMParticleLoadEvent = false;
$: if (trackMParticleAnalytics && !sentMParticleLoadEvent && CONFIG.league === 'fa' && CONFIG.tricode === 'tot' && $mergedParams && $mergedParams['event_id']) {
    sentMParticleLoadEvent = true;
    appsrv.getEventDetail($mergedParams['event_id']).then((rsp) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const attributes = {
            'competition_name': (_c = (_b = (_a = rsp.data) === null || _a === void 0 ? void 0 : _a.CalendarEventXml) === null || _b === void 0 ? void 0 : _b._attributes) === null || _c === void 0 ? void 0 : _c.Title,
            'competition_start_date': (_f = (_e = (_d = rsp.data) === null || _d === void 0 ? void 0 : _d.CalendarEventXml) === null || _e === void 0 ? void 0 : _e._attributes) === null || _f === void 0 ? void 0 : _f.Date,
            'competition_end_date': (_j = (_h = (_g = rsp.data) === null || _g === void 0 ? void 0 : _g.CalendarEventXml) === null || _h === void 0 ? void 0 : _h._attributes) === null || _j === void 0 ? void 0 : _j.EndTime,
        };
        ycAnalyticsTrackMParticle('click/tap', 'Competition Start', 'navigation', attributes);
    });
}
</script>

<CardBase {element}>
  <ActionButton onClick={handleClick} disabled={!formState.valid} title={buttonLabel}/>
</CardBase>
